import { UserManager, WebStorageStateStore } from 'oidc-client-ts'
import { BUXUS_API_BASE_URL } from '../abp/config'

function getAuthOriginFromApiBase(apiBase: string): string {
  return apiBase.replace(/\/api\/?$/, '')
}

function getAuthority(): string {
  const fromEnv = (import.meta.env.VITE_OIDC_AUTHORITY as string | undefined)?.trim()
  if (fromEnv) return fromEnv.endsWith('/') ? fromEnv : `${fromEnv}/`

  const origin = getAuthOriginFromApiBase(BUXUS_API_BASE_URL)
  return origin.endsWith('/') ? origin : `${origin}/`
}

function getClientId(): string {
  return (import.meta.env.VITE_OIDC_CLIENT_ID as string | undefined)?.trim() || 'Buxus_App'
}

function getScope(): string {
  return (
    (import.meta.env.VITE_OIDC_SCOPE as string | undefined)?.trim() ||
    'openid profile email offline_access Buxus'
  )
}

function getRedirectUri(): string {
  return `${window.location.origin}/auth/callback`
}

export const oidcManager = new UserManager({
  authority: getAuthority(),
  client_id: getClientId(),
  redirect_uri: getRedirectUri(),
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: getScope(),
  automaticSilentRenew: false,
  monitorSession: false,
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
})
